export default {
    ru: [
        {
            title: 'О выставке',
            items: [
                {
                    title: 'Общая информация',
                    link: 'pages/about',
                },
                {
                    title: 'План выставки',
                    link: process.env.PAVILION_EXPOSITION_URL,
                },
                {
                    title: 'Статическая экспозиция',
                    link: process.env.STATIC_EXPOSITION_URL,
                },
                {
                    title: 'Список участников',
                    link: 'pages/exhibitors-list',
                },
                {
                    title: 'Деловая программа',
                    link: 'pages/schedule',
                },
                {
                    title: 'Как добраться',
                    link: 'pages/location',
                },
                {
                    title: 'Время работы',
                    link: 'pages/opening-hours',
                },
            ],
        },
        {
            title: 'Участникам',
            items: [
                // {
                //     title: 'Личный кабинет',
                //     link: 'https://lk.rubae.ru',
                // },
                {
                    title: 'Заявка участника',
                    link: '/files/exhibit-application-ru.pdf',
                },
                {
                    title: 'Заявка участника на статику',
                    link: '/files/static-application-en.pdf',
                },
                {
                    title: 'Руководство участника',
                    link: '/files/exhibitor-manual-ru.pdf',
                },
                {
                    title: 'Дополнительные услуги',
                    link: '/files/Дополнительное оборудование.pdf',
                },
                {
                    title: 'Спонсорство и реклама',
                    link: '/files/RUBAE_2018_ru.pdf',
                },
                {
                    title: 'Газета Show Daily',
                    link: '/files/ShowDaily.pdf',
                },
                {
                    title: 'Визовая поддержка',
                    link: 'pages/visa-support',
                },
                {
                    title: 'Размещение в отеле',
                    link:
                        'http://eventsathilton.com/show/5b3cb1b81eccc8058488ee9b',
                },
            ],
        },
        {
            title: 'Посетителям',
            items: [
                // {
                //     title: 'Регистрация',
                //     link: 'pages/registration/',
                // },
                {
                    title: 'Время работы',
                    link: 'pages/opening-hours',
                },
                {
                    title: 'Как добраться',
                    link: 'pages/location',
                },
                {
                    title: 'Новости и пресса',
                    link: 'pages/news',
                },
                {
                    title: 'Аккредитация СМИ',
                    link: '/files/Форма_аккредитации_прессы_2018.docx',
                },
                {
                    title: 'Визовая поддержка',
                    link: 'pages/visa-support',
                },
                {
                    title: 'Размещение в отеле',
                    link:
                        'http://eventsathilton.com/show/5b3cb1b81eccc8058488ee9b',
                },
            ],
        },
        {
            title: 'Контакты',
            items: [
                // {
                //     title: 'Организационный комитет',
                //     link: 'pages/organizing-commitee',
                // },
                {
                    title: 'Генеральный застройщик',
                    link: 'pages/general-contractor',
                },
                {
                    title: 'Генеральный экспедитор',
                    link: 'pages/freight-forwarder',
                },
                {
                    title: 'Кейтеринг партнер',
                    link: 'pages/catering',
                },
            ],
        },
    ],

    en: [
        {
            title: 'About',
            items: [
                {
                    title: 'Genaral information',
                    link: 'pages/about',
                },
                {
                    title: 'Floor plan',
                    link: process.env.PAVILION_EXPOSITION_URL,
                },
                {
                    title: 'Static display',
                    link: process.env.STATIC_EXPOSITION_URL,
                },
                {
                    title: 'Exhibitors list',
                    link: 'pages/exhibitors-list',
                },
                {
                    title: 'Programe schedule',
                    link: 'pages/schedule',
                },
                {
                    title: 'Venue location',
                    link: 'pages/location',
                },
                {
                    title: 'Opening hours',
                    link: 'pages/opening-hours',
                },
            ],
        },
        {
            title: 'Exhibitor information',
            items: [
                // {
                //     title: 'Personal account',
                //     link: 'https://lk.rubae.ru',
                // },
                {
                    title: 'Exhibit application',
                    link: '/files/exhibit-application-en.pdf',
                },
                {
                    title: 'Static display application',
                    link: '/files/static-application-en.pdf',
                },
                {
                    title: 'Exhibitor manual',
                    link: '/files/exhibitor-manual-en.pdf',
                },
                {
                    title: 'Additional equipment',
                    link: '/files/Additional equipment 2018.pdf',
                },
                {
                    title: 'Marketing opportunities',
                    link: '/files/RUBAE_2018_en.pdf',
                },
                {
                    title: 'Show Daily newspapper',
                    link: '/files/ShowDaily.pdf',
                },
                {
                    title: 'Visa support',
                    link: 'pages/visa-support',
                },
                {
                    title: 'Hotel accommodation',
                    link:
                        'http://eventsathilton.com/show/5b3cb1b81eccc8058488ee9b',
                },
            ],
        },
        {
            title: 'Attendee',
            items: [
                // {
                //     title: 'Registration',
                //     link: 'pages/registration/',
                // },
                {
                    title: 'Opening hours',
                    link: 'pages/opening-hours',
                },
                {
                    title: 'Venue location',
                    link: 'pages/location',
                },
                {
                    title: 'News and Press',
                    link: 'pages/news',
                },
                {
                    title: 'Media accreditation',
                    link: 'pages/accreditation',
                },
                {
                    title: 'Visa support',
                    link: 'pages/visa-support',
                },
                {
                    title: 'Hotel accommodation',
                    link:
                        'http://eventsathilton.com/show/5b3cb1b81eccc8058488ee9b',
                },
            ],
        },
        {
            title: 'Contacts',
            items: [
                // {
                //     title: 'Organizing Committee',
                //     link: 'pages/organizing-commitee',
                // },
                {
                    title: 'General Contractor',
                    link: 'pages/general-contractor',
                },
                {
                    title: 'Official freight forwarder',
                    link: 'pages/freight-forwarder',
                },
                {
                    title: 'Catering partner',
                    link: 'pages/catering',
                },
            ],
        },
    ],
};



// WEBPACK FOOTER //
// ./src/data/navigation.js